import { Component, OnInit, Input } from '@angular/core';
import { CatalogsService } from 'src/app/services/catalogs-services/catalogs-services/catalogs.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-catalogs-catalogs-breadcrumb-card',
  templateUrl: './catalogs-catalogs-breadcrumb-card.component.html',
  styleUrls: ['./catalogs-catalogs-breadcrumb-card.component.scss']
})
export class CatalogsCatalogsBreadcrumbCardComponent implements OnInit {

  @Input() catalogs;
  selectedOption;
  filterOpened: boolean;
  viewDisposition;

  constructor(private userStorageService: UserStorageService,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private catalogsService: CatalogsService) {
                this.viewDisposition = 'grid';
              }

  ngOnInit() {
    if (this.userStorageService.getFilterDevices()) {
      this.toggleBreadcrumbFilter();
    }
  }

  public newCatalog() {
    this.router.navigate(['../catalog'], { relativeTo: this.activatedRoute.parent});
  }

  public toggleViewDisposition(viewDis) {
    this.viewDisposition = viewDis;
    this.catalogsService.toggleCatalogsDisposition(viewDis);
  }

  public toggleBreadcrumbFilter() {
    this.filterOpened = !this.filterOpened;
  }

  public search(event) {
    this.catalogsService.searchCatalogs(event.target.value);
  }
}
